import ObaBaseDAO from "./ObaBaseDAO";
import C5CompraModel from "../../model/C5CompraModel";

class ObaPedidoDAO extends ObaBaseDAO {
  private static instance: ObaPedidoDAO;
  private endpoint = `${super.getBasePath()}`;

  private constructor() {
    super();
  }

  public static getInstance(): ObaPedidoDAO {
    if (!ObaPedidoDAO.instance) {
      ObaPedidoDAO.instance = new ObaPedidoDAO();
    }
    return ObaPedidoDAO.instance;
  }

  public async postStoreApp(compraId: string) {
    return this.get(
      `REQ_OBA_APP_ORDER_${compraId}`,
      `https://api-admin-ecommerce.azurewebsites.net/v1/purchase/notification/newPurchaseNotify?PurchaseId=${compraId}`
    );
  }

  public async getPedidoStatus(compra: C5CompraModel): Promise<C5CompraModel> {
    return this.post(
      `REQ_OBA_STATUS_PEDIDO_${compra.compraId}`,
      `${this.endpoint}/pedido/status`,
      { nropedido: compra.compraId }
    ).then((r: any) => {
      compra.statusId = r.data.status;
      compra.statusAtualizacao = new Date(Date.parse(r.data.dtahorinclusao));

      switch (r.data.status) {
        case 1: // Efetuado
          compra.status = "Efetuado";
          break;
        case 4: // Problemas
          compra.status = "Problemas";
          break;
        case 5: // Cancelado
          compra.status = "Cancelado";
          break;
        case 6: // Aguardando Pagamento
          compra.status = "Aguardando Pagamento";
          break;
        case 7: // Pagamento Confirmado
          compra.status = "Pagamento Confirmado";
          break;
        case 8: // Analise Risco
          compra.status = "Analise Risco";
          break;
        case 17: // Despachado
          compra.status = "Despachado";
          break;
        case 90: // Faturado
          compra.status = "Faturado";
          break;
        case 92: // Entregue
          compra.status = "Entregue";
          break;
        case 99: // Troca
          compra.status = "Troca";
          break;
        case 100: // Cupom Próxima Compra
          compra.status = "Cupom Próxima Compra";
          break;
        case 108: // Alterar Forma de Pagamento
          compra.status = "Alterar Forma de Pagamento";
          break;
        case 109: // Iniciar manuseio
          compra.status = "Pagamento confirmado";
          break;
        case 110: // Preparando entrega
          compra.status = "Preparando entrega";
          break;
        case 150: // Pedido e-commerce com boleto em aberto
          compra.status = "Pedido e-commerce com boleto em aberto";
          break;
        case 151: // Pedido e-commerce com boleto quitado
          compra.status = "Pedido e-commerce com boleto quitado";
          break;
        default:
          break;
      }
      return compra;
    });
  }
}

export default ObaPedidoDAO;
